import { render } from "./FormaPagoList.vue?vue&type=template&id=47bcf43e&scoped=true"
import script from "./FormaPagoList.vue?vue&type=script&lang=js"
export * from "./FormaPagoList.vue?vue&type=script&lang=js"

import "./FormaPagoList.vue?vue&type=style&index=0&id=47bcf43e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bcf43e"]])

export default __exports__